export default __webpack_public_path__ + "static/media/logo.a2f38eb6.svg";